import { useEffect, useState } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import useMediaQuery from "../hooks/useMediaQuery";

const Link = ({ page, selectedPage, setSelectedpage }) => {
  const lowerCasePage = page.toLowerCase();
  return (
    <AnchorLink
      className={`${
        selectedPage === lowerCasePage ? "text-yellow" : ""
      } hover:text-yellow transition duration-500`}
      href={`#${lowerCasePage}`}
      onClick={() => setSelectedpage(lowerCasePage)}
    >
      {page}
    </AnchorLink>
  );
};

const Navbar = ({ isTopOfPage, selectedPage, setSelectedpage }) => {
  const [isMenuToggled, setMenuToggled] = useState();

  const isAboveSmallScreen = useMediaQuery("(min-width:768px)");
  const navbarBackground = isTopOfPage ? "" : "bg-red";
  console.log(isAboveSmallScreen, "is above sdmall scree");

  console.log("yo")
  return (
    <nav className={`${navbarBackground} z-40 w-full fixed top-0 py-6`}>
      <div className="flex items-center justify-between mx-auto w-5/6">
        <h4 className="font-playfair text-3xl font-bold">JE</h4>
        {/** DESKTOP NAV */}
        {isAboveSmallScreen ? (
          <div className="flex justify-between gap-16 font-opensans text-sm font-semibold">
            <Link page={"Home"} selectedPage={selectedPage} />
            <Link page={"Skills"} selectedPage={selectedPage} />
            <Link page={"Projects"} selectedPage={selectedPage} />
            <Link page={"Testimonial"} selectedPage={selectedPage} />
            <Link page={"Contact"} selectedPage={selectedPage} />
          </div>
        ) : (
          <button
            className="rounded-full bg-red p-2"
            onClick={() => setMenuToggled(!isMenuToggled)}
          >
            <img alt="menu-icon" src="../assets/menu-icon.svg"></img>
          </button>
        )}
        {/** mobile menu pop up */}
        {!isAboveSmallScreen && isMenuToggled && (
          <div className="fixed right-0 bottom-0 h-full bg-blue w-[300px]">
            {/** close icons */}
            <div className="flex justify-end p-12">
              <button onClick={() => setMenuToggled(!isMenuToggled)}>
                <img alt="close-icon" src="../assets/close-icon.svg"></img>
              </button>
            </div>
            {/** MENU ITEMS */}
            <div className="flex flex-col gap-10 ml-[33%] text-2xl text-deep-blue ">
              <Link page={"Home"} selectedPage={selectedPage} />
              <Link page={"Skills"} selectedPage={selectedPage} />
              <Link page={"Projects"} selectedPage={selectedPage} />
              <Link page={"Testimonial"} selectedPage={selectedPage} />
              <Link page={"Contact"} selectedPage={selectedPage} />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
